import React from 'react';
import Col from '../../components/Col';
import Row from '../../components/Row';
import Heading from 'src/components/Heading';
import { useBranding } from 'src/branding/BrandingContextProvider';
import { AccountSettingsSection } from 'src/pages/Settings/components/AccountSettingsSection/AccountSettingsSection';
import { PasswordSection } from 'src/pages/Settings/components/PasswordSection/PasswordSection';
import { CompanySettingsSection } from 'src/pages/Settings/components/CompanySettingsSection/CompanySettingsSection';
import { QRCodeSection } from 'src/pages/Settings/components/QRCodeSection/QRCodeSection';
import { NotificationTip } from 'src/pages/Settings/components/NotificationTip/NotificationTip';
import { NotificationsSection } from 'src/pages/Settings/components/Notificationssection/Notificationssection';
import SystemLevelNotificationsSection from 'src/pages/Settings/components/SystemLevelNotificationSection/SystemLevelNotificationSection';
import { MFASignupForm } from './components/MFASignup/MFASignupForm';
import WalkthroughBackupUploader from 'src/pages/Settings/components/WalkthroughBackupUploader/WalkthroughBackupUploader';
import GenericDivider from 'src/components/GenericDivider/GenericDivider';
import { useSelector } from 'react-redux';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import WithNavigation from 'src/layouts/WithNavigation/WithNavigation';
import './Settings.scss';

const Settings: React.FC = () => {
  const { branding } = useBranding();
  const user = useSelector(selectAuthenticatedUser);

  const isAdmin: boolean =
    user.roles[0].role.name === 'Admin' ||
    user.roles[0].role.name === 'Super Admin';

  return (
    <WithNavigation
      title="Settings"
      top={<Heading headline="Settings" />}
      bottom={
        <div className="settings">
          <Row mdCenter>
            <Col xs={12} md={8}>
              <AccountSettingsSection />
              <PasswordSection />
              {branding.permissions.twoFASetting && <MFASignupForm />}
              <CompanySettingsSection />
              <NotificationsSection />
              <SystemLevelNotificationsSection />
              <QRCodeSection />
              <NotificationTip />
              {isAdmin && (
                <>
                  <GenericDivider variant="sky" spacing="lg" />
                  <WalkthroughBackupUploader />
                </>
              )}
            </Col>
          </Row>
        </div>
      }
    />
  );
};

export default Settings;
